import * as tslib_1 from "tslib";
import { PropostaStateService } from './../../../../../shared/states/proposta-state.service';
import { MicrocreditoService } from './../../../../services/microcredito.service';
import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FaefStateService } from './../faef-state.service';
import * as toastr from 'toastr';
export class ParecerAgenteComponent {
    constructor(fb, state, propostaState, service) {
        this.fb = fb;
        this.state = state;
        this.propostaState = propostaState;
        this.service = service;
        this.next = new EventEmitter();
        this.previous = new EventEmitter();
        this.loading = new EventEmitter(true);
    }
    ngOnInit() {
        this.createForms();
        const faef = this.state.getLast();
        if (faef.faefResultado) {
            const { parecerAgente, notaConfiancaCliente, valorEmprestaria } = faef.faefResultado;
            this.parecerForm.patchValue({
                parecerAgente,
                notaConfiancaCliente,
                valorEmprestaria: String(valorEmprestaria || '')
            }, {
                emitEvent: false
            });
        }
    }
    get valoresNotaConfianca() {
        return Array.from({ length: 11 }, (x, i) => i);
    }
    onClickNext() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.updateState();
            yield this.saveFaef();
            this.next.emit();
        });
    }
    onClickPrevious() {
        this.updateState();
        this.previous.emit();
    }
    updateState() {
        const faef = this.state.getLast();
        const { parecerAgente, notaConfiancaCliente, valorEmprestaria } = this.parecerForm.value;
        faef.faefResultado = Object.assign({}, faef.faefResultado, { parecerAgente: parecerAgente && parecerAgente.trim() ? parecerAgente : 'SEM PARECER', notaConfiancaCliente: Number(notaConfiancaCliente), valorEmprestaria: Number(valorEmprestaria) });
        this.state.setState(faef);
    }
    createForms() {
        this.parecerForm = this.fb.group({
            parecerAgente: [''],
            notaConfiancaCliente: ['', Validators.required],
            valorEmprestaria: ['', Validators.required]
        });
    }
    saveFaef() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.loading.emit(true);
            try {
                const proposta = this.propostaState.getLast();
                const faef = this.state.getLast();
                yield this.service.save(faef, proposta.id);
            }
            catch (error) {
                console.log(error);
                toastr.error('Não foi possível salvar a FAEF no servidor. Seus dados permanecem salvo no dispositivo.', 'Falha ao comunicar com servidor');
                throw error;
            }
            finally {
                this.loading.emit(false);
            }
        });
    }
}
